import React from 'react';
import type { ToothData } from '@/types';

// Import all tooth images (adjust paths based on your actual file names)
import tooth1 from '../../assets/img/tooth-01.png';
import tooth2 from '../../assets/img/tooth-02.png';
import tooth3 from '../../assets/img/tooth-03.png';
import tooth4 from '../../assets/img/tooth-04.png';
import tooth5 from '../../assets/img/tooth-05.png';
import tooth6 from '../../assets/img/tooth-06.png';
import tooth7 from '../../assets/img/tooth-07.png';
import tooth8 from '../../assets/img/tooth-08.png';
import tooth9 from '../../assets/img/tooth-09.png';
import tooth10 from '../../assets/img/tooth-10.png';
import tooth11 from '../../assets/img/tooth-11.png';
import tooth12 from '../../assets/img/tooth-12.png';
import tooth13 from '../../assets/img/tooth-13.png';
import tooth14 from '../../assets/img/tooth-14.png';
import tooth15 from '../../assets/img/tooth-15.png';
import tooth16 from '../../assets/img/tooth-16.png';
import tooth17 from '../../assets/img/tooth-17.png';
import tooth18 from '../../assets/img/tooth-18.png';
import tooth19 from '../../assets/img/tooth-19.png';
import tooth20 from '../../assets/img/tooth-20.png';
import tooth21 from '../../assets/img/tooth-21.png';
import tooth22 from '../../assets/img/tooth-22.png';
import tooth23 from '../../assets/img/tooth-23.png';
import tooth24 from '../../assets/img/tooth-24.png';
import tooth25 from '../../assets/img/tooth-25.png';
import tooth26 from '../../assets/img/tooth-26.png';
import tooth27 from '../../assets/img/tooth-27.png';
import tooth28 from '../../assets/img/tooth-28.png';
import tooth29 from '../../assets/img/tooth-29.png';
import tooth30 from '../../assets/img/tooth-30.png';
import tooth31 from '../../assets/img/tooth-31.png';
import tooth32 from '../../assets/img/tooth-32.png';

// Import all implant tooth images
import implant1 from '../../assets/implant/tooth-01.png';
import implant2 from '../../assets/implant/tooth-02.png';
import implant3 from '../../assets/implant/tooth-03.png';
import implant4 from '../../assets/implant/tooth-04.png';
import implant5 from '../../assets/implant/tooth-05.png';
import implant6 from '../../assets/implant/tooth-06.png';
import implant7 from '../../assets/implant/tooth-07.png';
import implant8 from '../../assets/implant/tooth-08.png';
import implant9 from '../../assets/implant/tooth-09.png';
import implant10 from '../../assets/implant/tooth-10.png';
import implant11 from '../../assets/implant/tooth-11.png';
import implant12 from '../../assets/implant/tooth-12.png';
import implant13 from '../../assets/implant/tooth-13.png';
import implant14 from '../../assets/implant/tooth-14.png';
import implant15 from '../../assets/implant/tooth-15.png';
import implant16 from '../../assets/implant/tooth-16.png';
import implant17 from '../../assets/implant/tooth-17.png';
import implant18 from '../../assets/implant/tooth-18.png';
import implant19 from '../../assets/implant/tooth-19.png';
import implant20 from '../../assets/implant/tooth-20.png';
import implant21 from '../../assets/implant/tooth-21.png';
import implant22 from '../../assets/implant/tooth-22.png';
import implant23 from '../../assets/implant/tooth-23.png';
import implant24 from '../../assets/implant/tooth-24.png';
import implant25 from '../../assets/implant/tooth-25.png';
import implant26 from '../../assets/implant/tooth-26.png';
import implant27 from '../../assets/implant/tooth-27.png';
import implant28 from '../../assets/implant/tooth-28.png';
import implant29 from '../../assets/implant/tooth-29.png';
import implant30 from '../../assets/implant/tooth-30.png';
import implant31 from '../../assets/implant/tooth-31.png';
import implant32 from '../../assets/implant/tooth-32.png';

// Map tooth numbers to their normal images
const TOOTH_IMAGES: Record<number, string> = {
  1: tooth1, 2: tooth2, 3: tooth3, 4: tooth4, 5: tooth5, 6: tooth6, 7: tooth7, 8: tooth8,
  9: tooth9, 10: tooth10, 11: tooth11, 12: tooth12, 13: tooth13, 14: tooth14, 15: tooth15, 16: tooth16,
  17: tooth17, 18: tooth18, 19: tooth19, 20: tooth20, 21: tooth21, 22: tooth22, 23: tooth23, 24: tooth24,
  25: tooth25, 26: tooth26, 27: tooth27, 28: tooth28, 29: tooth29, 30: tooth30, 31: tooth31, 32: tooth32,
};

// Map tooth numbers to their implant images
const IMPLANT_IMAGES: Record<number, string> = {
  1: implant1, 2: implant2, 3: implant3, 4: implant4, 5: implant5, 6: implant6, 7: implant7, 8: implant8,
  9: implant9, 10: implant10, 11: implant11, 12: implant12, 13: implant13, 14: implant14, 15: implant15, 16: implant16,
  17: implant17, 18: implant18, 19: implant19, 20: implant20, 21: implant21, 22: implant22, 23: implant23, 24: implant24,
  25: implant25, 26: implant26, 27: implant27, 28: implant28, 29: implant29, 30: implant30, 31: implant31, 32: implant32,
};

// Tooth SVG paths for realistic tooth shapes
const TOOTH_PATHS = {
  molar: "M 20 10 Q 15 5 10 10 L 8 30 Q 10 35 15 35 Q 20 35 22 30 L 20 10 Z",
  premolar: "M 18 12 Q 15 8 12 12 L 10 30 Q 12 33 15 33 Q 18 33 20 30 L 18 12 Z",
  canine: "M 17 15 Q 15 10 13 15 L 12 32 Q 15 35 18 32 L 17 15 Z",
  incisor: "M 16 18 L 14 18 L 13 32 Q 15 34 17 32 L 16 18 Z",
  lowerMolar: "M 20 25 Q 15 30 10 25 L 8 5 Q 10 0 15 0 Q 20 0 22 5 L 20 25 Z",
  lowerPremolar: "M 18 23 Q 15 27 12 23 L 10 5 Q 12 2 15 2 Q 18 2 20 5 L 18 23 Z",
  lowerCanine: "M 17 20 Q 15 25 13 20 L 12 3 Q 15 0 18 3 L 17 20 Z",
  lowerIncisor: "M 16 17 L 14 17 L 13 3 Q 15 1 17 3 L 16 17 Z"
};

function getToothPath(toothNumber: number) {
  if (toothNumber >= 1 && toothNumber <= 16) {
    if ([1, 2, 3, 14, 15, 16].includes(toothNumber)) return TOOTH_PATHS.molar;
    if ([4, 5, 12, 13].includes(toothNumber)) return TOOTH_PATHS.premolar;
    if ([6, 11].includes(toothNumber)) return TOOTH_PATHS.canine;
    return TOOTH_PATHS.incisor;
  }
  if ([17, 18, 19, 30, 31, 32].includes(toothNumber)) return TOOTH_PATHS.lowerMolar;
  if ([20, 21, 28, 29].includes(toothNumber)) return TOOTH_PATHS.lowerPremolar;
  if ([22, 27].includes(toothNumber)) return TOOTH_PATHS.lowerCanine;
  return TOOTH_PATHS.lowerIncisor;
}

function getToothInfo(toothNumber: number, status?: string) {
  const names: Record<number, string> = {
    1: 'Upper Right Third Molar', 2: 'Upper Right Second Molar', 3: 'Upper Right First Molar',
    4: 'Upper Right Second Premolar', 5: 'Upper Right First Premolar', 6: 'Upper Right Canine',
    7: 'Upper Right Lateral Incisor', 8: 'Upper Right Central Incisor', 9: 'Upper Left Central Incisor',
    10: 'Upper Left Lateral Incisor', 11: 'Upper Left Canine', 12: 'Upper Left First Premolar',
    13: 'Upper Left Second Premolar', 14: 'Upper Left First Molar', 15: 'Upper Left Second Molar',
    16: 'Upper Left Third Molar', 17: 'Lower Left Third Molar', 18: 'Lower Left Second Molar',
    19: 'Lower Left First Molar', 20: 'Lower Left Second Premolar', 21: 'Lower Left First Premolar',
    22: 'Lower Left Canine', 23: 'Lower Left Lateral Incisor', 24: 'Lower Left Central Incisor',
    25: 'Lower Right Central Incisor', 26: 'Lower Right Lateral Incisor', 27: 'Lower Right Canine',
    28: 'Lower Right First Premolar', 29: 'Lower Right Second Premolar', 30: 'Lower Right First Molar',
    31: 'Lower Right Second Molar', 32: 'Lower Right Third Molar'
  };
  
  // Select the appropriate image based on status
  const image = status === 'implant' 
    ? IMPLANT_IMAGES[toothNumber] 
    : TOOTH_IMAGES[toothNumber];
  
  return { 
    name: names[toothNumber] || `Tooth ${toothNumber}`,
    image: image
  };
}

interface ToothCellProps {
  toothNumber: number;
  data: ToothData | null;
  isSelected: boolean;
  onClick: () => void;
  onContextMenu?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  isUpper: boolean;
}

export function ToothCell({
  toothNumber,
  data,
  isSelected,
  onClick,
  onContextMenu,
  isUpper
}: ToothCellProps) {
  // Get status first to pass to getToothInfo
  const getStatus = () => {
    if (!data) return 'present';
    if (data.status === 'missing') return 'missing';
    if (data.status === 'implant') return 'implant';
    if (data.status === 'pontic') return 'pontic';
    if (data.status === 'crown') return 'crown';
    return data.status || 'present';
  };

  const status = getStatus();
  const toothInfo = getToothInfo(toothNumber, status);

  // Periodontal issues
  const hasPerioIssues = data?.sites?.some((site) => site.pocket_depth && site.pocket_depth >= 5) ?? false;

  // Restorative data
  const hasCrown = data?.restorative?.crown?.present;
  const hasFillings = (data?.restorative?.fillings?.length || 0) > 0;
  const hasCaries = data?.restorative?.caries?.present;
  const hasRootCanal = data?.restorative?.root_canal?.treated;
  const needsTreatment = !!data?.restorative?.treatment_needed?.procedure;
  const treatmentPriority = data?.restorative?.treatment_needed?.priority;

  const handleContextMenu = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    if (onContextMenu) {
      onContextMenu(e);
    }
  };

  return (
    <div
      className={`
        w-16 h-28 flex flex-col items-center justify-center rounded-lg cursor-pointer 
        transition-all duration-150 select-none border-2 relative
        ${isSelected 
          ? 'ring-4 ring-blue-600 ring-offset-2 border-blue-600 bg-blue-100 scale-110 z-10 shadow-lg' 
          : 'border-gray-300'
        }
        ${status === 'missing' && 'opacity-50 bg-gray-100'}
        ${status === 'implant' && 'bg-blue-50'}
        ${status === 'pontic' && 'bg-purple-50'}
        ${status === 'crown' && 'bg-yellow-50'}
        ${hasCaries && status !== 'missing' && 'bg-red-50'}
        ${hasPerioIssues && status === 'present' && !hasCaries && 'bg-orange-50'}
        ${!hasPerioIssues && !hasCaries && status === 'present' && 'bg-gray-50 hover:bg-gray-100'}
      `}
      onClick={onClick}
      onContextMenu={handleContextMenu}
      title={`${toothInfo.name} - Right-click to change status`}
      tabIndex={0}
      role="button"
      aria-pressed={isSelected}
    >
      {/* Treatment Priority Indicator */}
      {needsTreatment && (
        <div
          className={`
            absolute top-1 right-1 w-3 h-3 rounded-full border-2 border-white
            ${treatmentPriority === 'urgent' && 'bg-red-500'}
            ${treatmentPriority === 'soon' && 'bg-orange-500'}
            ${treatmentPriority === 'elective' && 'bg-green-500'}
            ${!treatmentPriority && 'bg-yellow-500'}
          `}
          title={`Treatment needed: ${data?.restorative?.treatment_needed?.procedure} (${treatmentPriority || 'unset'})`}
        />
      )}

      {/* Tooth Number */}
      <span className="text-xs font-medium text-gray-700">
        {toothNumber}
      </span>

      {/* Tooth Visual */}
      <div className="relative w-12 h-14 my-1">
        <img 
          src={toothInfo.image} 
          alt={toothInfo.name} 
          className={`w-full h-full object-contain ${status === 'missing' ? 'opacity-20' : 'opacity-100'}`}
        />
    
        {status === 'missing' && (
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-red-500 text-xl font-bold">X</span>
          </div>
        )}
        {/* Removed the 'I' overlay for implant since we're now showing implant image */}
        {status === 'crown' && (
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-yellow-600 text-sm font-bold">C</span>
          </div>
        )}
        {status === 'pontic' && (
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-purple-600 text-sm font-bold">P</span>
          </div>
        )}
        {hasCaries && status === 'present' && (
          <div className="absolute bottom-0 left-0 right-0 flex items-center justify-center">
            <span className="text-red-600 text-lg font-bold">●</span>
          </div>
        )}
        
        {/* Filling indicator (small dots at bottom) */}
        {hasFillings && status !== 'missing' && (
          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-gray-500 border border-white" />
        )}
      </div>

      {/* Indicators - Fixed Grid Layout */}
      <div className="grid grid-cols-2 gap-0.5 w-full px-1 min-h-[20px]">
        {/* Mobility */}
        <div className="flex items-center justify-center">
          {data?.mobility && data.mobility > 0 ? (
            <span className="text-[10px] px-1 bg-orange-100 text-orange-700 rounded whitespace-nowrap">
              M{data.mobility}
            </span>
          ) : (
            <span className="text-[10px] text-transparent">M0</span>
          )}
        </div>
        
        {/* Furcation */}
        <div className="flex items-center justify-center">
          {data?.furcation && data.furcation > 0 ? (
            <span className="text-[10px] px-1 bg-purple-100 text-purple-700 rounded whitespace-nowrap">
              F{data.furcation}
            </span>
          ) : (
            <span className="text-[10px] text-transparent">F0</span>
          )}
        </div>
        
        {/* Crown */}
        <div className="flex items-center justify-center">
          {hasCrown && status !== 'crown' ? (
            <span className="text-[10px] px-1 bg-yellow-100 text-yellow-700 rounded whitespace-nowrap">
              Cr
            </span>
          ) : (
            <span className="text-[10px] text-transparent">Cr</span>
          )}
        </div>
        
        {/* Root Canal */}
        <div className="flex items-center justify-center">
          {hasRootCanal ? (
            <span className="text-[10px] px-1 bg-purple-100 text-purple-700 rounded whitespace-nowrap">
              RC
            </span>
          ) : (
            <span className="text-[10px] text-transparent">RC</span>
          )}
        </div>
      </div>
    </div>
  );
}
